export const stats: [string, string][] = [
  ['10', 'VOLUMI COMPLETI'],
  ['600', 'PAGINE DI PROGRAMMA'],
  ['60', 'PAGINE PER ANNO'],
  ['100%', 'ALLINEATO AL CURRICOLO'],
]
